import React from 'react'

const Shopingcontent = ({img, textContent, smallContent}) => {
  return (
    
<div className='flex'>
            <img className=" mt-[10px] h-[58px] pr-[5px]" src={img} alt='cart'/>
            <div className='flex flex-col'>
            <p className='font-manrope text-[#00296B] text-[24px] leading-[32px] font-semibold py-[5px]'>{textContent}</p>
            <p className='font-manrope text-[#666] text-[16px] leading-[24px] font-semibold '>{smallContent}</p>
            </div>
            </div>
  )
}



export default Shopingcontent
